import {create} from 'zustand'
import {persist} from 'zustand/middleware'

export type ReaderFontSize = 'sm' | 'md' | 'lg'
export type ReaderLineHeight = 'snug' | 'normal' | 'relaxed'
export type ReaderTheme = 'light' | 'dark' | 'sepia'
export type ReaderWidth = 'narrow' | 'regular' | 'wide'

export const FONT_SIZE_VALUES: Record<ReaderFontSize, number> = {
  sm: 16,
  md: 18,
  lg: 20,
}

export const LINE_HEIGHT_VALUES: Record<ReaderLineHeight, number> = {
  snug: 1.55,
  normal: 1.7,
  relaxed: 1.85,
}

export const WIDTH_VALUES: Record<ReaderWidth, number> = {
  narrow: 520,
  regular: 640,
  wide: 760,
}

type ReaderSettingsState = {
  fontSize: ReaderFontSize
  lineHeight: ReaderLineHeight
  theme: ReaderTheme
  width: ReaderWidth
  setFontSize: (size: ReaderFontSize) => void
  setLineHeight: (value: ReaderLineHeight) => void
  setTheme: (theme: ReaderTheme) => void
  setWidth: (width: ReaderWidth) => void
}

export const useReaderSettings = create<ReaderSettingsState>()(
  persist(
    set => ({
      fontSize: 'md',
      lineHeight: 'normal',
      theme: 'light',
      width: 'regular',
      setFontSize: fontSize => set({fontSize}),
      setLineHeight: lineHeight => set({lineHeight}),
      setTheme: theme => set({theme}),
      setWidth: width => set({width}),
    }),
    {name: 'tellus.news.reader'},
  ),
)
